"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.list.title': 'Questions',
    'question.list.empty': 'No questions found',
};
